import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=37995e6a"
import script from "./file-uploader.vue?vue&type=script&lang=js"
export * from "./file-uploader.vue?vue&type=script&lang=js"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=37995e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports